/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ReplyAuthOut } from './replyAuthOut';

export interface ReplyOut {
  reply_id: string;
  from_email_masked: string;
  from_email?: string | null;
  subject?: string | null;
  received_at: string;
  authenticated: boolean;
  auth: ReplyAuthOut;
  handled_action: string | null;
  handled_at: string | null;
  text_body?: string | null;
}
